import React, { useEffect } from 'react'
import designConfig from '@design-config'

const DesignTokens: React.FC = () => {
  useEffect(() => {
    document.documentElement.style.setProperty('--radius', designConfig.radius)
    document.documentElement.style.setProperty('--radius-sm', designConfig.radiusSm)
    document.documentElement.style.setProperty('--radius-pill', designConfig.radiusPill)
    document.documentElement.style.setProperty('--radius-xs', designConfig.radiusXs)
  }, [])

  return null
}

export default DesignTokens
